module.exports = __webpack_public_path__ + "static/media/8.4c58df2c.jpg";